var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0794 10.4782C33.4506 10.8495 33.6591 11.353 33.6591 11.878C33.6591 12.403 33.4506 12.9066 33.0794 13.2779L17.2394 29.1179C16.8681 29.4891 16.3646 29.6976 15.8395 29.6976C15.3145 29.6976 14.811 29.4891 14.4397 29.1179L6.51968 21.1979C6.159 20.8244 5.95943 20.3243 5.96394 19.8051C5.96845 19.286 6.17669 18.7894 6.5438 18.4223C6.9109 18.0552 7.40751 17.8469 7.92666 17.8424C8.44581 17.8379 8.94596 18.0375 9.31939 18.3981L15.8395 24.9183L30.2797 10.4782C30.651 10.107 31.1545 9.89844 31.6795 9.89844C32.2045 9.89844 32.7081 10.107 33.0794 10.4782Z",
    fill: "#003E6B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.db5136facef2f94975dd6854035e85be.svg";
export { ForwardRef as ReactComponent };